import React from 'react';
import PropTypes from 'prop-types';
import './AddButtonLong.css';

const AddButtonLong = ({ click }) => (
  <span
    className="AddButtonLong"
    style={{ textDecoration: 'none', right: 0 }}
    onClick={click}
  >
    Добавить
  </span>
);

AddButtonLong.propTypes = {
  click: PropTypes.func.isRequired
};

export default AddButtonLong;



// WEBPACK FOOTER //
// ./src/components/AddButtonLong.js